<nav class='navbar navbar-expand navbar-custom'>
  <div class='container-fluid'>
    <div class='me-auto d-flex align-items-center'>
      <ng-container *ngFor='let item of itemLeft'
                    class='navbar-custom--left'>
        <pt-navbar-item
          *ngxPermissionsOnly='item.permissVisible'
          [item]='item'
          class='me-2'>
        </pt-navbar-item>
      </ng-container>
    </div>
    <div class='ms-auto d-flex align-items-center'>

      <pt-navbar-item
        *ngIf="appId && appId === CONSOLE"
        [item]='debugItem'
        class='me-2'>
      </pt-navbar-item>

      <button
        type="button"
        *ngIf="devMode.isNoProduction()"
        class="btn btn-lg "
        [ngClass]="devMode.debugModeEnabled() ? 'btn-primary' : 'btn-secondary'"
        style="font-size: 12px; border-radius: 0; width: 80px; margin-right: 10px;"
        (click)="toggleDevMode()">
       {{devMode.debugModeEnabled() ? 'Disattiva Debug' : 'Attiva Debug'}}
      </button>

      <ng-container *ngFor='let item of itemRight'
                    class='navbar-custom--right'>
        <pt-navbar-item
          *ngxPermissionsOnly='item.permissVisible'
          [item]='item'>
        </pt-navbar-item>
      </ng-container>
    </div>
  </div>
</nav>

